module.exports = __webpack_public_path__ + "media/assets/icons/triangle-up-5c18b7ba5e8dbcb1aa3cef912a9694ab.svg";